import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-lg-row" }
const _hoisted_2 = { class: "flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0" }
const _hoisted_3 = { class: "card card-flush" }
const _hoisted_4 = {
  class: "card-header pt-7",
  id: "kt_chat_contacts_header"
}
const _hoisted_5 = { class: "container p-0" }
const _hoisted_6 = { class: "row mb-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label"
}, "Address", -1)
const _hoisted_8 = { class: "row mb-10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label"
}, "Standard", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "functional" }, "Functional", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "modern" }, "Modern", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "luxurious" }, "Luxurious", -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "row mb-10" }
const _hoisted_15 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label"
}, "Bedrooms", -1)
const _hoisted_17 = {
  class: "col-sm",
  style: {"padding-right":"0px"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label"
}, "Floor", -1)
const _hoisted_19 = { class: "row mb-10" }
const _hoisted_20 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label"
}, "Simple Beds", -1)
const _hoisted_22 = {
  class: "col-sm",
  style: {"padding-right":"0px"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label"
}, "Double Beds", -1)
const _hoisted_24 = { class: "row mb-10" }
const _hoisted_25 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label"
}, "Bunk Beds", -1)
const _hoisted_27 = {
  class: "col-sm",
  style: {"padding-right":"0px"}
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label"
}, "Sofa Beds", -1)
const _hoisted_29 = { class: "row mb-10" }
const _hoisted_30 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label",
  style: {"padding-left":"10px"}
}, "Elevator", -1)
const _hoisted_32 = {
  class: "col-sm",
  style: {"padding-right":"0px"}
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label",
  style: {"padding-left":"10px"}
}, "Wifi", -1)
const _hoisted_34 = { class: "row mb-10" }
const _hoisted_35 = { class: "flex-lg-row-fluid ms-lg-7 ms-xl-10" }
const _hoisted_36 = { class: "card card-flush" }
const _hoisted_37 = {
  class: "card-header pt-7",
  id: "kt_chat_contacts_header"
}
const _hoisted_38 = { class: "container p-0" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "row mb-5" }
const _hoisted_41 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label",
  style: {"padding-left":"10px"}
}, "Title", -1)
const _hoisted_43 = { class: "row mb-5" }
const _hoisted_44 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label",
  style: {"padding-left":"10px"}
}, "Summary", -1)
const _hoisted_46 = { class: "row mb-5" }
const _hoisted_47 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label",
  style: {"padding-left":"10px"}
}, "Space", -1)
const _hoisted_49 = { class: "row mb-5" }
const _hoisted_50 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label",
  style: {"padding-left":"10px"}
}, "Guest Access", -1)
const _hoisted_52 = { class: "row mb-5" }
const _hoisted_53 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label",
  style: {"padding-left":"10px"}
}, "Neighbourhood", -1)
const _hoisted_55 = { class: "row mb-5" }
const _hoisted_56 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label",
  style: {"padding-left":"10px"}
}, "Getting Around", -1)
const _hoisted_58 = { class: "row mb-5" }
const _hoisted_59 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label",
  style: {"padding-left":"10px"}
}, "Other Things", -1)
const _hoisted_61 = { class: "row mb-5" }
const _hoisted_62 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label",
  style: {"padding-left":"10px"}
}, "Interactions With Guests", -1)
const _hoisted_64 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "address",
                id: "exampleFormControlInput1",
                class: "form-control form-control-solid",
                placeholder: "Address",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.address) = $event))
              }, null, 512), [
                [_vModelText, _ctx.formData.address]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "aria-label": "Select example",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.standard) = $event))
              }, _hoisted_13, 512), [
                [_vModelSelect, _ctx.formData.standard]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "exampleFormControlInput1",
                  class: "form-control form-control-solid",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.bedrooms) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.bedrooms]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "exampleFormControlInput1",
                  class: "form-control form-control-solid",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.floor) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.floor]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "exampleFormControlInput1",
                  class: "form-control form-control-solid",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.simple_beds) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.simple_beds]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "exampleFormControlInput1",
                  class: "form-control form-control-solid",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.double_beds) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.double_beds]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "exampleFormControlInput1",
                  class: "form-control form-control-solid",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.bunk_beds) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.bunk_beds]
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "exampleFormControlInput1",
                  class: "form-control form-control-solid",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.sofa_beds) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.sofa_beds]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.elevator) = $event)),
                  id: "flexSwitchDefault"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.formData.elevator]
                ]),
                _hoisted_31
              ]),
              _createElementVNode("div", _hoisted_32, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.wifi) = $event)),
                  id: "flexSwitchDefault"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.formData.wifi]
                ]),
                _hoisted_33
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("a", {
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.requestNewAdvert && _ctx.requestNewAdvert(...args))),
                class: "btn btn-primary"
              }, "Submit")
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            (_ctx.advert.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _withDirectives(_createElementVNode("input", {
                        type: "address",
                        id: "exampleFormControlInput1",
                        class: "form-control form-control-solid",
                        placeholder: "Title",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.advert[0].Title) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.advert[0].Title]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _withDirectives(_createElementVNode("textarea", {
                        type: "text",
                        id: "exampleFormControlInput1",
                        class: "form-control form-control-solid",
                        placeholder: "Title",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.advert[0].Summary) = $event)),
                        rows: "3",
                        "max-rows": "6"
                      }, null, 512), [
                        [_vModelText, _ctx.advert[0].Summary]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _withDirectives(_createElementVNode("textarea", {
                        type: "address",
                        id: "exampleFormControlInput1",
                        class: "form-control form-control-solid",
                        placeholder: "Title",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.advert[0].Space) = $event)),
                        rows: "4",
                        "max-rows": "6"
                      }, null, 512), [
                        [_vModelText, _ctx.advert[0].Space]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _withDirectives(_createElementVNode("textarea", {
                        type: "address",
                        id: "exampleFormControlInput1",
                        class: "form-control form-control-solid",
                        placeholder: "Title",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.advert[0].guest_access) = $event)),
                        rows: "4",
                        "max-rows": "6"
                      }, null, 512), [
                        [_vModelText, _ctx.advert[0].guest_access]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _hoisted_54,
                      _withDirectives(_createElementVNode("textarea", {
                        type: "address",
                        id: "exampleFormControlInput1",
                        class: "form-control form-control-solid",
                        placeholder: "Title",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.advert[0].neighbourhood) = $event)),
                        rows: "4",
                        "max-rows": "6"
                      }, null, 512), [
                        [_vModelText, _ctx.advert[0].neighbourhood]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _withDirectives(_createElementVNode("textarea", {
                        type: "address",
                        id: "exampleFormControlInput1",
                        class: "form-control form-control-solid",
                        placeholder: "Title",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.advert[0].getting_around) = $event)),
                        rows: "4",
                        "max-rows": "6"
                      }, null, 512), [
                        [_vModelText, _ctx.advert[0].getting_around]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _hoisted_60,
                      _withDirectives(_createElementVNode("textarea", {
                        type: "address",
                        id: "exampleFormControlInput1",
                        class: "form-control form-control-solid",
                        placeholder: "Title",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.advert[0].other_things) = $event)),
                        rows: "8",
                        "max-rows": "10"
                      }, null, 512), [
                        [_vModelText, _ctx.advert[0].other_things]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _hoisted_63,
                      _withDirectives(_createElementVNode("textarea", {
                        type: "address",
                        id: "exampleFormControlInput1",
                        class: "form-control form-control-solid",
                        placeholder: "Title",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.advert[0].interaction) = $event)),
                        rows: "4",
                        "max-rows": "6"
                      }, null, 512), [
                        [_vModelText, _ctx.advert[0].interaction]
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_64, "Fill the Form and Submit to generate Advert's"))
          ])
        ])
      ])
    ])
  ]))
}